import { useState, useRef, useEffect, useCallback } from "react";
import { isNotValidNullUndefile } from "../control/Constant";

const ReusableSelect = (props) => {
  const {
    options,
    value,
    onChange,
    placeholder = "Select...",
    className,
    showValue,
    findValue,
    isMulti,
    isDisable,
    showSearch,
    lplSearchSelect
  } = props;

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [dropUp, setDropUp] = useState(false);
  const dropdownRef2 = useRef(null);
  const [searchValue,setSearchvalue] = useState('')

useEffect(() => {
  if (open && dropdownRef2.current && props?.openUp == true) {
    const rect = dropdownRef2.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // if bottom space is less than 200px, open upward
    if (windowHeight - rect.bottom < 200) {
      setDropUp(true);
    } else {
      setDropUp(false);
    }
  }
}, [open]);







  // close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
        setSearchvalue('')
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

    const handleSelect = (option) => {
        if (isMulti == true) {
            const exists = value?.length > 0 && value?.some((v) => v == option);
            let newValue;
            if (exists) {
                newValue = value?.length > 0 && value?.filter((v) => v != option);
            } else {
                newValue = [...(value || []), option];
            }

            if (isMulti == true) {
                let hideArrValue = ['3', '13', '14', '15']
                let intersection = hideArrValue?.length > 0 && hideArrValue?.filter(x => newValue?.includes(x));
                if (intersection?.length > 0) {
                    hideArrValue?.splice(hideArrValue?.indexOf(intersection?.[0]), 1)
                    for (let i = 0; i < hideArrValue?.length; i++) {
                     options?.length > 0 && options?.filter((disableFields) => {
                            if (disableFields?.value == hideArrValue[i]) {
                                disableFields['disabled'] = true
                            }

                        })
                    }
                } else {
                    for (let i = 0; i < hideArrValue.length; i++) {
                        options?.filter((disableFields) => {
                            if (disableFields.value == hideArrValue[i]) {
                                disableFields['disabled'] = false
                            }

                        })
                    }

                }

            }








            onChange(newValue);
        } else {
            onChange(option);
            setOpen(false);
        }
    };



    const handleRemove = (option) => {
        const newValue = value?.length > 0 && value?.filter((v) => v !== option);
        onChange(newValue);

        if (isMulti == true) {
            let hideArrValue = ['3', '13', '14', '15']
            for (let i = 0; i < hideArrValue?.length; i++) {
               options?.length > 0 && options?.filter((disableFields) => {
                    if (disableFields?.value == hideArrValue[i]) {
                        disableFields['disabled'] = false
                    }
                })
            }
        }
    };
    const handleToggle = () => {
        if (!open) {
            const rect = dropdownRef2.current?.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // check if enough space below
            if (rect && windowHeight - rect.bottom < 200) {
                setDropUp(true);
            } else {
                setDropUp(false);
            }
        }
        setOpen(!open);
    };
    const isSelected = (option) => isMulti == true && (typeof value == "object") ?  value?.some((v) => v == option[findValue]) : value?.[findValue] == option?.[findValue];
    

    const searchOptions = useCallback((dataArray) => {
    return dataArray.filter((e) => {
        const value = typeof e === "string" ? e : e?.label;
        if (!value) return false;

        const normalizedValue = value.toLowerCase();
        const normalizedSearch = searchValue.toLowerCase();

        if (searchValue.length === 1) {
        return normalizedValue.startsWith(normalizedSearch);
        } else {
        return normalizedValue.includes(normalizedSearch);
        }
    });
    }, [searchValue]);


    return (
        <div ref={dropdownRef} className={`relative`} >
            {/* Trigger */}
            <button type="button" style={{ width: className }} onClick={() => handleToggle()}
                // disabled={findValue == 'subtenantId'}
                disabled={isDisable}
                className={`rounded-md border border-gray-300 bg-white px-3 py-1 text-left shadow-sm 
             focus:border-blue-500 focus:ring-2 focus:ring-blue-500 flex justify-between items-center
             disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed ${showSearch == true ? '!bg-[#FAFBFC] !shadow-none !text-[14px] !px-1.5' : '' } ${lplSearchSelect == true ? '!border !border-gray-300 rounded-md !bg-[white]':''} ${lplSearchSelect!=true&&showSearch==true?'!border-none':''}`}
            >
                <div className="flex flex-wrap gap-2 items-center px-0 py-1" style={{fontSize:"14px"}}>
                    {isMulti == true ? (
                    value?.length > 0 ? (
                                <span
                                    className="text-white/100 bg-[#720d21]/90 px-2 py-1 rounded-md text-sm flex items-center gap-1"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {value?.length > 1
                                        ? `${options?.find((ele) => ele[findValue] == value[0])?.[showValue]} (+${value.length - 1})`
                                        : options?.find((ele) => ele[findValue] == value[0])?.[showValue]}

                                    <button
                                        className="ml-1 text-white/100 hover:text-white"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemove(value?.length > 0 ? value?.[0] : []); // remove first or handle differently
                                        }}
                                    >
                                        ✕
                                    </button>
                                </span>
                            )
                             : (
                            <span className="text-gray-400" style={{fontSize:"13px"}}>{placeholder}</span>
                        )
                    ) : (
                        <span className={lplSearchSelect == true ? '!text-[16px]':'' }>{value ? options.length > 0 && options?.find((o) => o[findValue] == value)?.[showValue] : placeholder}</span>
                    )}
                </div>
                <span className="text-gray-500 mx-1">▼</span>
            </button>

            {/* Dropdown */}

            {open && (
                <ul
                    ref={dropdownRef2}
                    className={`absolute z-10 max-h-60 overflow-y-auto rounded-md border border-gray-300 bg-white shadow-lg 
                ${dropUp ? "bottom-full mb-1" : "mt-1"}`}
                    style={{ width: className, fontSize: "13px" }}
                >
                    {showSearch == true && placeholder != 'General/IOLTA' && <li><input className="w-[90%] px-2 py-1 border border-gray-300 rounded-md mx-1 mt-2" placeholder="Search" onChange={(e)=>{setSearchvalue(e.target.value)}} /></li>}
                    {options?.length > 0 ? (showSearch == true ? searchOptions(options): options)?.map((option, index) => {
                        const isDisabled = option?.disabled;
                        return (
                            <li
                                key={index}
                                onClick={() => !isDisabled && handleSelect(option[findValue])}
                                className={`ps-2 py-1 flex items-start justify-between ${isDisabled ? "cursor-not-allowed text-gray-400 bg-gray-100"
                                    : "cursor-pointer"} ${isSelected(option) ? "bg-[#720d21]/10 font-medium" : ""} ${lplSearchSelect == true ? 'py-1 text-[14px] px-2':''}`}>
                                <span className="text-start">{option[showValue]}</span>
                                {isSelected(option) && !isDisabled && (
                                    <span className="text-[#720d21] font-bold" style={{ fontSize: '13px' }}>✔</span>
                                )}
                            </li>
                        );
                    }) : (
                         <li className={`px-4 py-1 flex items-center justify-between`}>No Data found</li>
                    )}
                </ul>
            )}

        </div>
    );
};

export default ReusableSelect;
